<template>
    <div :class="['not-play-status',{statusFull:isFull}]">
      <p class="back" @click="back">
        <img src="@/assets/img/live/back.png" alt="" @click="back" class="control-icon">
      </p>
        <div v-if="loading">
          <van-loading />
        </div>
        <div v-else-if="!onLine">
          请检查网络状态
        </div>
        <div v-else-if="liveStatus === 0">
          直播未开始
        </div>
        <div v-else-if="liveStatus === 2">
          直播已结束
        </div>
        <div v-else @click="clickPlayer">
          <img src="@/assets/img/live/play.png" alt="">
          <span>直播中，点击播放</span>
        </div>
    </div>
</template>
<script>
export default {
  name: 'LiveStatus',
  props: ['loading', 'liveStatus', 'onLine', 'isFull'],
  data() {
    return {

    };
  },
  mounted() {
  },
  methods: {
    clickPlayer() {
      this.$emit('clickPlayer');
    },
    back() {
      if (this.isFull) {
        this.$emit('operation', 'changFull');
      } else {
        this.$router.back();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
    .not-play-status {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: calc(100vw * 0.5625);
    background: #000;
    div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: #fff;
        font-size: 32px;
        img {
          margin-bottom: 20px;
        }
    }
    .back {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1111111;
      width: 100px;
      height: 100px;
      padding: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &.statusFull {
      top: 0;
      left: 0;
      width: 75% !important;
      height: 100vw !important;
      transform: translateZ(100px);
    }
  }
</style>
